import { render, staticRenderFns } from "./CloudLabDetail.vue?vue&type=template&id=0f31fdd1&scoped=true&"
import script from "./CloudLabDetail.vue?vue&type=script&lang=js&"
export * from "./CloudLabDetail.vue?vue&type=script&lang=js&"
import style0 from "./CloudLabDetail.vue?vue&type=style&index=0&id=0f31fdd1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f31fdd1",
  null
  
)

export default component.exports